import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import { I18nProvider } from "@/i18n";
import { AuthProvider } from "@/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Chatbot from "@/components/Chatbot";
import PromoPopup from "@/components/PromoPopup";
import Home from "@/pages/Home";
import Expeditions from "@/pages/Expeditions";
import ExpeditionDetail from "@/pages/ExpeditionDetail";
import Story from "@/pages/Story";
import Contact from "@/pages/Contact";
import PageView from "@/pages/PageView";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import BookingReturn from "@/pages/BookingReturn";
import PayPage from "@/pages/PayPage";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";
import CookieBanner from "@/components/CookieBanner";
import { AdminProvider } from "@/admin/AdminContext";
import Admin from "@/admin/Admin";
import PageLoader from "@/components/PageLoader";
import api from "@/lib/api";

function SiteSettings() {
  useEffect(() => {
    api.get("/site-settings").then(({ data }) => {
      const root = document.documentElement;
      root.style.setProperty("--hs-title-scale", data?.title_scale || 1);
      root.style.setProperty("--hs-body-scale", data?.body_scale || 1);
    }).catch(() => {});
  }, []);
  return null;
}

function Shell() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const isPublic = !location.pathname.startsWith("/admin") && !location.pathname.startsWith("/payer/") && !location.hash?.includes("session_id=");
  useEffect(() => {
    if (!isPublic) { setLoading(false); return; }
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 650);
    return () => clearTimeout(t);
  }, [location.pathname, isPublic]);

  if (location.pathname.startsWith("/admin")) {
    return (
      <AdminProvider>
        <Admin />
      </AdminProvider>
    );
  }
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  if (location.pathname.startsWith("/payer/")) {
    return (
      <Routes>
        <Route path="/payer/:token" element={<PayPage />} />
      </Routes>
    );
  }
  return (
    <>
      <PageLoader show={loading} />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/expeditions" element={<Expeditions />} />
          <Route path="/expeditions/:slug" element={<ExpeditionDetail />} />
          <Route path="/histoire" element={<Story />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/p/:slug" element={<PageView />} />
          <Route path="/acces" element={<Auth />} />
          <Route path="/reservation/retour" element={<BookingReturn />} />
          <Route path="/mentions-legales" element={<LegalPage key="mentions-legales" />} />
          <Route path="/cgv" element={<LegalPage key="cgv" />} />
          <Route path="/confidentialite" element={<LegalPage key="confidentialite" />} />
          <Route path="/cookies" element={<LegalPage key="cookies" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      <Chatbot />
      <CookieBanner />
      <PromoPopup />
    </>
  );
}

function App() {
  return (
    <div className="App grain">
      <HelmetProvider>
        <I18nProvider>
          <AuthProvider>
            <SiteSettings />
            <BrowserRouter>
              <Shell />
            </BrowserRouter>
            <Toaster position="top-right" theme="dark" />
          </AuthProvider>
        </I18nProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
